module.exports = __webpack_public_path__ + "img/artichaut_md.8d68c6fb.jpg";